import { Actions } from '~/Actions';
import { ADD_FEATURES_TO_STORE } from '~/Actions/ActionFeatures';

export interface FeaturesState {
    shipFeatureMap: ShipFeatureMap;
}

export const initialState: FeaturesState = {
    shipFeatureMap: {},
};

const ReducerFeatures = (state: FeaturesState = initialState, action: Actions) => {
    switch (action.type) {
        case ADD_FEATURES_TO_STORE:
            return {
                ...state,
                shipFeatureMap: action.shipFeatureMap,
            };

        default:
            return { ...state };
    }
};

export default ReducerFeatures;
